import { render, staticRenderFns } from "./AlarmsConfigurationList.vue?vue&type=template&id=1c25cf83&scoped=true&"
import script from "./AlarmsConfigurationList.vue?vue&type=script&lang=js&"
export * from "./AlarmsConfigurationList.vue?vue&type=script&lang=js&"
import style0 from "./AlarmsConfigurationList.vue?vue&type=style&index=0&id=1c25cf83&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c25cf83",
  null
  
)

export default component.exports